export default "__VITE_ASSET__BoxvJHOG__"